import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Licensure } from 'src/app/shared/models/user';
import { MobileUiService } from 'src/app/shared/services/mobile-ui.service';

@Component({
  selector: 'app-profile-licensure',
  templateUrl: './profile-licensure.component.html',
  styleUrls: ['./profile-licensure.component.scss']
})
export class ProfileLicensureComponent implements OnInit {
  @Input() licensures = new BehaviorSubject<Licensure[]>([]);
  licensuresHeadElements = ['Type', 'State', 'Year', 'Status'];
  isMobile = new BehaviorSubject<boolean>(false);

  constructor(private mobileUiService: MobileUiService) {
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
  }

}
